import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import logoInstituto from "../assets/logo.png";
import "../styles/Login.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { showErrorAlert, showSuccessAlert } from "../utils/alerts";


export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const usuarioGuardado = localStorage.getItem("usuarioRecordado");
    if (usuarioGuardado) {
      setEmail(usuarioGuardado);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      showSuccessAlert({
        title: "Sesión iniciada",
        text: "Has ingresado correctamente.",
      });
      const recordar = document.getElementById("recordar").checked;
      if (recordar) {
        localStorage.setItem("usuarioRecordado", email);
      }
      navigate("/dashboard");
    } catch (error) {
      showErrorAlert({
        title: "Error",
        text: error.message || "No se pudo iniciar sesión.",
      });
    }
  };

  return (
    <div className="login-container d-flex justify-content-center align-items-center vh-100 bg-dark text-white">
      <div className="login-box p-4 rounded shadow-lg" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="text-center mb-4">
          <div className="logo mb-2">

            <img
              src={logoInstituto}
              alt="Logo Instituto"
              className="mb-3"
              style={{ width: "90px", height: "90px" }}
            />

          </div>
          <h3 className="fw-bold">Instituto Franco Condado</h3>
          <p className="text-light">Web App Preparatoria</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Usuario */}
          <div className="mb-3">
            {/*} <label className="form-label">Usuario</label>{*/}
            <div className="input-group">
              <span className="input-group-text bg-dark text-white">
                <FontAwesomeIcon icon={faUser} className="me-2" />
              </span>
              <input
                type="text"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ingresa tu usuario"
                required
              />
            </div>
          </div>

          {/* Contraseña */}
          <div className="mb-3">
            {/*} <label className="form-label">Contraseña</label> {*/}
            <div className="input-group">
              <span className="input-group-text bg-dark text-white">
                <FontAwesomeIcon icon={faLock} className="me-2" />
              </span>
              <input
                type={mostrar ? "text" : "password"}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contraseña"
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setMostrar(!mostrar)}
              >
                <FontAwesomeIcon icon={mostrar ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          {/* Recordar usuario */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="recordar" />
              <label className="form-check-label" htmlFor="recordar">Recordar usuario</label>
            </div>
            <a href="#" className="text-light text-decoration-none">¿Olvidaste tu contraseña?</a>
          </div>

          {/* Botón */}
          <button type="submit" className="btn btn-primary w-100 fw-bold">Iniciar Sesión</button>
        </form>

        <div className="text-center mt-4 text-light small">
          © 2026 Web App. Todos los derechos reservados.
        </div>
      </div>
    </div>
  );
}
